if (typeof ol !== 'undefined') {
    require('./torque');
}
